<div>
  <ng-container>
    <ng-container *ngFor="let item of allDummyItems | paginate: { itemsPerPage: carPagination.perPage, currentPage: carPagination.currentPage }"></ng-container>
  </ng-container>
  <pagination-template #p="paginationApi">
    <div class="listpager">
      <div class="inner_listpager">
        <a *ngIf="!p.isFirstPage()"
          [routerLink]="[currentRouterLinkPath]"
          [queryParams]="getPagerQueryParams(p.getCurrent() -1)"
          (click)="p.previous()"
          class="to_prev_page pager_btn"
          [class.disabled]="p.isFirstPage()"
        ><span class="arrow">&laquo;</span>{{ lang | i18nSelect: strings.carList.previous }}</a>
        <span *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
            <a [routerLink]="[currentRouterLinkPath]"
              [queryParams]="getPagerQueryParams(page.value)"
              (click)="p.setCurrent(page.value)"
              *ngIf="p.getCurrent() !== page.value && isPageNumber(page.label)"
              class="pager_btn"
            >{{ page.label }}</a>
            <span *ngIf="p.getCurrent() !== page.value && !isPageNumber(page.label)" class="pager_dots">{{ page.label }}</span>
            <strong *ngIf="p.getCurrent() === page.value">{{ page.label }}</strong>
        </span>
        <a *ngIf="!p.isLastPage()"
          [routerLink]="[currentRouterLinkPath]"
          [queryParams]="getPagerQueryParams(p.getCurrent() + 1)"
          (click)="p.next()"
          class="to_next_page pager_btn"
          [class.disabled]="p.isLastPage()"
        >{{ lang | i18nSelect: strings.carList.next }}<span class="arrow">&raquo;</span></a>
      </div>
    </div>
</pagination-template>

</div>